import { GateAddModalForm } from "./GateAddModalForm";

const GateAddModalFormWrapper = ({
  listing,
  device,
  setDevice,
  setOpenGateAddModal,
  getGateLists,
  changeStatus,
  setChangeStatus
}) => {
    return (
      <GateAddModalForm
        listing={listing}
        device={device}
        setDevice={setDevice}
        setOpenGateAddModal={setOpenGateAddModal}
        getGateLists={getGateLists}
        changeStatus={changeStatus}
        setChangeStatus={setChangeStatus}
      />
    );
  }

export { GateAddModalFormWrapper };
